import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { DeleteIcon } from "../assets/icons";
import {
  getDistricts,
  getNeighborhoods,
  getStreets,
} from "../services/addressService";
import { cn } from "../utils/cn";
import { addTask, deleteTaskList, getTaskList, removeTask } from "../services/dutyService";
import { Toast } from "primereact/toast";
import { MultiSelect } from 'primereact/multiselect';
// 📅 Tarih formatlayıcı
const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

const AddressAssignments = ({ onFilterChange, currentFilters = {} }) => {
  const [selectedFilters, setSelectedFilters] = useState({
    ...currentFilters,
    datetime: "",
  });
  const [districts, setDistricts] = useState([]);
  const [neighborhoods, setNeighborhoods] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState({
    districts: false,
    neighborhoods: false,
    addresses: false,
  });

  const [apartments, setApartments] = useState([]);
  const [loadingApartments, setLoadingApartments] = useState(false);
  const [removing, setRemoving] = useState(false);
  const [apartmentGroups, setApartmentGroups] = useState({});

  // Yeni state: Grup seçenekleri
  const [tableData, setTableData] = useState([]);

  const [dateRange, setDateRange] = useState({
    baslangic: new Date().toISOString().split("T")[0],
    bitis: new Date().toISOString().split("T")[0],
  });

  const toast = useRef(null);

  const fetchTaskLists = async (filters = {}) => {
 
    try {
      const response = await getTaskList();

      const data = await response.data;
      if (Array.isArray(data.data)) {
        const formatted = data.data
          .filter((item) => !item.isDeleted)
          .map((item) => ({
            id: item.id,
            district: item.district,
            neighborhood: item.neighbourhood,
            address: item.address || "",
            datetime: item.date,
            groupName:item.groupName
          }));
        setTableData(formatted);
      } else {
        console.warn("TaskLists verisi beklenen formatta değil:", data);
      }
    } catch (error) {
      console.error("TaskLists verisi çekilirken hata:", error);
    }
  };

  useEffect(() => {
    fetchDistricts();
    fetchTaskLists();
  }, []);

  const fetchDistricts = async () => {
    try {
      setLoading((prev) => ({ ...prev, districts: true }));
      const response = await getDistricts();
      if (response.status === 200) {
        setDistricts(response.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch districts:", error);
    } finally {
      setLoading((prev) => ({ ...prev, districts: false }));
    }
  };

  useEffect(() => {
    if (selectedFilters.district?.value) {
      fetchNeighborhoods(selectedFilters.district.value);
    } else {
      setNeighborhoods([]);
      setAddresses([]);
      setSelectedFilters((prev) => ({
        ...prev,
        neighborhood: null,
        address: null,
      }));
    }
  }, [selectedFilters.district]);

  const fetchNeighborhoods = async (districtId) => {
    try {
      setLoading((prev) => ({ ...prev, neighborhoods: true }));
      const response = await getNeighborhoods(districtId);
      if (response.status === 200) {
        setNeighborhoods(response.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch neighborhoods:", error);
    } finally {
      setLoading((prev) => ({ ...prev, neighborhoods: false }));
    }
  };

  useEffect(() => {
    if (selectedFilters.neighborhood?.value) {
      fetchAddresses(selectedFilters.neighborhood.value);
    } else {
      setAddresses([]);
      setSelectedFilters((prev) => ({ ...prev, address: null }));
    }
  }, [selectedFilters.neighborhood]);

  const fetchAddresses = async (neighborhoodId) => {
    try {
      setLoading((prev) => ({ ...prev, addresses: true }));
      const response = await getStreets(neighborhoodId);
      if (response.status === 200) {
        setAddresses(response.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch addresses:", error);
    } finally {
      setLoading((prev) => ({ ...prev, addresses: false }));
    }
  };

  const handleInputChange = (key, value) => {
    let newFilters = {};
    if (!value || (Array.isArray(value) && value.length === 0)) {
      newFilters = { ...selectedFilters };
      delete newFilters[key];
    } else {
      newFilters = {
        ...selectedFilters,
        [key]: value,
      };
    }
    setSelectedFilters(newFilters);
    if (onFilterChange) onFilterChange(newFilters);
  };

  const handleAddClick = async () => {
    if (
      !selectedFilters.district ||
      !selectedFilters.neighborhood ||
      !selectedFilters.address ||
      !selectedFilters.datetime
    ) {
      alert("Lütfen tüm alanları doldurun!");
      return;
    }

    setLoadingApartments(true);
    try {
      const response = await addTask({
        district: selectedFilters.district.label,
        neighborhood: selectedFilters.neighborhood.label,
        address: selectedFilters.address,
        datetime: "2025-01-01",
        day: selectedFilters.datetime,
      });
      if (response.data.message === "Başarılı") {
          // Başarılı durumda toaster göster
          toast.current.show({
            severity: 'success',
            summary: 'Başarılı',
            detail: 'Görev başarıyla eklendi',
            life: 3000
          });
          await fetchTaskLists();
      }
    } catch (error) {
      console.error("❗ fetch çağrısında hata:", error);
      setApartments([]);
    } finally {
      setLoadingApartments(false);
    }
  };

  // Ekleme ile aynı filtreler (ilçe + mahalle + seçili sokaklar + gün) ile toplu silme.
  const handleRemoveClick = async () => {
    if (
      !selectedFilters.district ||
      !selectedFilters.neighborhood ||
      !selectedFilters.address ||
      !selectedFilters.datetime
    ) {
      alert("Lütfen tüm alanları doldurun!");
      return;
    }

    const streets = Array.isArray(selectedFilters.address)
      ? selectedFilters.address
      : [selectedFilters.address];
    const confirmed = window.confirm(
      `${selectedFilters.datetime} günü için seçili ${streets.length} sokağın kayıtları silinecek. Onaylıyor musunuz?`
    );
    if (!confirmed) return;

    setRemoving(true);
    try {
      const response = await removeTask({
        district: selectedFilters.district.label,
        neighborhood: selectedFilters.neighborhood.label,
        address: selectedFilters.address,
        day: selectedFilters.datetime,
      });
      if (response.data.message === "Başarılı") {
        toast.current.show({
          severity: "success",
          summary: "Başarılı",
          detail: `${response.data.data} kayıt silindi`,
          life: 3000,
        });
        await fetchTaskLists();
      } else {
        toast.current.show({
          severity: "warn",
          summary: "Uyarı",
          detail: response.data.message,
          life: 3000,
        });
      }
    } catch (error) {
      console.error("❗ silme çağrısında hata:", error);
      toast.current.show({
        severity: "error",
        summary: "Hata",
        detail: "Silme işlemi sırasında bir hata oluştu.",
        life: 3000,
      });
    } finally {
      setRemoving(false);
    }
  };


  const handleDelete = async (id) => {
    const confirmed = window.confirm(
      "Bu kaydı silmek istediğinize emin misiniz?"
    );
    if (!confirmed) return;

    try {
      const response = await deleteTaskList(id);

      // Silme başarılıysa, tabloyu güncelle
      setTableData((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Silme işlemi sırasında hata oluştu:", error);
      alert("Silme işlemi sırasında bir hata oluştu. Lütfen tekrar deneyin.");
    }
  };

  return (
    <div className="people-container neighborhood-container">
      <Toast ref={toast} />
      <div className="filter-form" style={{ padding: "0" }}>
        <div className="form-row">
          <div className="form-group">
            <label>İlçe</label>
            <select
              value={selectedFilters.district?.value || ""}
              onChange={(e) => {
                const selectedDistrict = districts.find(
                  (d) => d.id === e.target.value
                );
                handleInputChange(
                  "district",
                  selectedDistrict
                    ? {
                        value: selectedDistrict.id,
                        label: selectedDistrict.ad,
                      }
                    : null
                );
              }}
              className="filter-input"
              disabled={loading.districts}
            >
              <option value="">İlçe Seçiniz</option>
              {districts.map((district) => (
                <option key={district.id} value={district.id}>
                  {district.ad}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Mahalle</label>
            <select
              value={selectedFilters.neighborhood?.value || ""}
              onChange={(e) => {
                const selectedNeighborhood = neighborhoods.find(
                  (n) => n.id === e.target.value
                );
                handleInputChange(
                  "neighborhood",
                  selectedNeighborhood
                    ? {
                        value: selectedNeighborhood.id,
                        label: selectedNeighborhood.ad,
                      }
                    : null
                );
              }}
              className="filter-input"
              disabled={loading.neighborhoods || !selectedFilters.district}
            >
              <option value="">Mahalle Seçiniz</option>
              {neighborhoods.map((neighborhood) => (
                <option key={neighborhood.id} value={neighborhood.id}>
                  {neighborhood.ad}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Adres (Sokak)</label>
          

            <MultiSelect
              value={selectedFilters.address || []}
              options={addresses.map(street => ({
                label: street.ad,
                value: street.ad
              }))}
              onChange={(e) => handleInputChange("address", e.target.value)}
              optionLabel="label"
              placeholder="Sokak Seçiniz"
              className="filter-input"
              disabled={loading.streets || !selectedFilters.neighborhood}
              filter
            />
          </div>

          <div className="form-group">
            <label>Ziyaret Tarihi</label>
            <select   value={selectedFilters.datetime || ""}  onChange={(e) => handleInputChange("datetime", e.target.value)}
              className={cn("filter-input p-inputtext p-component date-input")}
              style={{height: '45px'}}>
                <option value="">Seçiniz</option>
                <option value="Pazartesi">Pazartesi</option>
                <option value="Salı">Salı</option>
                <option value="Çarşamba">Çarşamba</option>
                <option value="Perşembe">Perşembe</option>
                <option value="Cuma">Cuma</option>
                <option value="Cumartesi">Cumartesi</option>
                <option value="Pazar">Pazar</option>
              </select>
            
          </div>

          <div
            className="form-group"
            style={{ minWidth: "210px", alignSelf: "flex-end" }}
          >
            <div style={{ display: "flex", gap: "10px" }}>
              <button
                type="button"
                className="neighborhood-filter-submit-button"
                onClick={handleAddClick}
                style={{ flex: 1, position: "relative" }}
                disabled={
                  loading.districts ||
                  loading.neighborhoods ||
                  loading.addresses ||
                  loadingApartments ||
                  removing
                }
              >
                Ekle
              </button>
              <button
                type="button"
                className="neighborhood-filter-delete-button"
                onClick={handleRemoveClick}
                style={{ flex: 1, position: "relative" }}
                disabled={
                  loading.districts ||
                  loading.neighborhoods ||
                  loading.addresses ||
                  loadingApartments ||
                  removing
                }
              >
                Sil
              </button>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "none"}} className="border-area hidden">
        <div className="filter-area">
          <h1 className="page-title">Ziyaret Filtrele</h1>
          <div
            className="filter-form"
            style={{ display: "flex", padding: "0" }}
          >
            <input
              type="date"
              className="filter-input"
              value={dateRange.baslangic}
              onChange={(e) =>
                setDateRange((prev) => ({ ...prev, baslangic: e.target.value }))
              }
            />

            <input
              type="date"
              className="filter-input"
              value={dateRange.bitis}
              onChange={(e) =>
                setDateRange((prev) => ({ ...prev, bitis: e.target.value }))
              }
            />
            <button
              type="button"
              className="filter-button"
              onClick={() => fetchTaskLists(dateRange)}
            >
              Filtrele
            </button>
          </div>
        </div>
      </div>
      <h2 style={{marginTop: '20px'}}>Ziyaretler</h2>
      {tableData.length > 0 && (
        <DataTable 
          value={tableData} 
          className="apartments-table"
          sortMode="multiple"
          showGridlines
          stripedRows
          paginator
          rows={15}
          rowsPerPageOptions={[15, 30, 50]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Toplam {totalRecords} kayıttan {first} - {last} arası gösteriliyor"
        >
          <Column field="district" header="İlçe" sortable></Column>
          <Column field="neighborhood" header="Mahalle" sortable></Column>
          <Column field="address" header="Sokak" sortable></Column>
          <Column field="groupName" header="Gün" sortable></Column>
          <Column body={(row) => (
            <button
              type="button"
              onClick={() => handleDelete(row.id)}
              style={{
                backgroundColor: "red",
                color: "white",
                border: "none",
                padding: "6px 10px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              <DeleteIcon className="nav-icon" color="#fff" />
            </button>
          )}></Column>
        </DataTable>
      )}

      {tableData.length === 0 && (
        <p style={{ marginTop: "20px", fontStyle: "italic", color: "#666" }}>
          Henüz eklenmiş kayıt yok.
        </p>
      )}

      <style jsx>{`
        .form-row {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }

        .form-group {
          flex: 1;
          min-width: 150px;
        }

        label {
          display: block;
          margin-bottom: 5px;
          font-weight: bold;
        }

        .filter-input {
          width: 100%;
          padding: 8px;
          border: 1px solid #ddd;
          border-radius: 4px;
          height: 45px;
        }

        .filter-input.active {
          background-color: #007acc;
          color: white;
        }

        .apartments-table {
          margin-top: 20px;
        }

        .apartments-table .p-datatable-thead > tr > th {
          background-color: #18964e !important;
          color: white !important;
          font-weight: 600 !important;
          height: 60px !important;
          border: 1px solid #ccc !important;
          text-align: center !important;
        }

        .apartments-table .p-datatable-thead > tr > th .p-column-header-content {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          height: 100% !important;
        }

        .apartments-table .p-datatable-thead > tr > th .p-column-title {
          color: white !important;
          font-weight: 600 !important;
        }

        .apartments-table .p-datatable-tbody > tr > td {
          border: 1px solid #ccc !important;
          padding: 8px !important;
          text-align: center !important;
        }

        .apartments-table .p-datatable-tbody > tr:nth-child(even) {
          background-color: #f9f9f9 !important;
        }

        .apartments-table .p-datatable-tbody > tr:hover {
          background-color: #f0f0f0 !important;
        }

        .apartments-table .p-sortable-column-icon {
          color: white !important;
        }

        .apartments-table .p-sortable-column:hover {
          background-color: #147a3d !important;
        }

        .apartments-table .p-paginator {
          background-color: #f8f9fa !important;
          border: 1px solid #dee2e6 !important;
          border-top: none !important;
        }

        .apartments-table .p-paginator .p-paginator-pages .p-paginator-page {
          border: 1px solid #dee2e6 !important;
          background-color: white !important;
          color: #495057 !important;
        }

        .apartments-table .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
          background-color: #18964e !important;
          border-color: #18964e !important;
          color: white !important;
        }

        .apartments-table .p-paginator .p-paginator-pages .p-paginator-page:hover {
          background-color: #147a3d !important;
          border-color: #147a3d !important;
          color: white !important;
        }

        .apartments-table .p-paginator .p-paginator-first,
        .apartments-table .p-paginator .p-paginator-prev,
        .apartments-table .p-paginator .p-paginator-next,
        .apartments-table .p-paginator .p-paginator-last {
          border: 1px solid #dee2e6 !important;
          background-color: white !important;
          color: #495057 !important;
        }

        .apartments-table .p-paginator .p-paginator-first:hover,
        .apartments-table .p-paginator .p-paginator-prev:hover,
        .apartments-table .p-paginator .p-paginator-next:hover,
        .apartments-table .p-paginator .p-paginator-last:hover {
          background-color: #18964e !important;
          border-color: #18964e !important;
          color: white !important;
        }

        .apartments-table .p-paginator .p-paginator-first.p-disabled,
        .apartments-table .p-paginator .p-paginator-prev.p-disabled,
        .apartments-table .p-paginator .p-paginator-next.p-disabled,
        .apartments-table .p-paginator .p-paginator-last.p-disabled {
          background-color: #e9ecef !important;
          border-color: #dee2e6 !important;
          color: #6c757d !important;
        }

        .apartments-table .p-paginator .p-dropdown {
          border: 1px solid #dee2e6 !important;
        }

        .apartments-table .p-paginator .p-dropdown:hover {
          border-color: #18964e !important;
        }

        .p-dropdown-label.p-inputtext {
          line-height: 43px !important;
          padding-left: 10px !important;
        }

        .neighborhood-filter-submit-button {
          background-color: #18964e;
          color: white;
          border: none;
          padding: 10px;
          border-radius: 5px;
          cursor: pointer;
          font-weight: 600;
          height: 45px;
        }

        .neighborhood-filter-submit-button:disabled {
          background-color: #a0a0a0;
          cursor: not-allowed;
        }

        .filter-form .neighborhood-filter-delete-button {
          background-color: #d32f2f;
          color: white;
          border: none;
          padding: 10px;
          border-radius: 5px;
          cursor: pointer;
          font-weight: 600;
          height: 45px;
        }

        .filter-form .neighborhood-filter-delete-button:disabled {
          background-color: #a0a0a0;
          cursor: not-allowed;
        }

        .filter-form input {
          width: 200px;
          height: 45px;
          border: 1px solid #ddd;
          border-radius: 4px;
          margin-right: 10px;
        }

        .filter-form button {
          background-color: #18964e;
          color: white;
          border: none;
          padding: 10px;
          border-radius: 5px;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

export default AddressAssignments;
